import template   from './my-rlink.html'
import controller from './my-rlink.controller'
import './my-rlink.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-rlink/my-rlink.component.js